import { SHOW_LOGIN_POPUP, HIDE_LOGIN_POPUP } from '../../constant';

const initialState = false;

const LoginPopupReducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case HIDE_LOGIN_POPUP:
      return false;
    case SHOW_LOGIN_POPUP:
      return true;
    default:
      return state;
  }
};

export default LoginPopupReducer;
